package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.runtime.Composable
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState

@Composable
actual fun PlatformBackHandler(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {}